export enum ChoiceTypes {
  MOBILE_TYPE = 'mobileType',
  MOBILE_ICON = 'mobileIcon',
  DISTANCE = 'distance-unit',
  SPEED = 'speed-unit',
  OPERATOR = 'operator',
  HARDWARE_TYPE = 'hardwareType',
  TIMEZONE = 'timezone',
  PERMISSION_ACTION = 'permissionAction',
  PERMISSION = 'permission',
  PROFILE_TYPE = 'profileType',
  SENSOR_TYPE = 'sensorType',
  COMMAND = 'command',
  ALARM = 'alarm',
  MAINTENANCE_CLASS = 'maintenanceClass',
  MAINTENANCE_ACTION = 'maintenanceActionType',
}

